(function($){
        
    const   $WhoDrinkDrives = $('#WhoDrinkDrives');

    // Quickest condition to do a page check 
    if ($WhoDrinkDrives.length > 0) {
    
        // Adding body class...
        $('body').addClass('all-bad');

        // Mobile check
        let isMob = /(Android|webOS|iPhone|iPad|iPod|Opera Mini)/i.test(navigator.userAgent);

        if (isMob) {
            $('body').addClass('isMobile');
        }

        // Chrome iOS
        let isChriOS;
        if(/CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent)){
            isChriOS = true;
        }else{
            isChriOS = false;
        }

        if (isChriOS) {
            $('body').addClass('isChriOS');
        }

        // alert(isChriOS);


        // GSAP Animation
        let isPlaying = false;        

        const   $title1         = document.getElementById('Ani__title1'),
                $title2         = document.getElementById('Ani__title2'),
                $desc           = document.getElementById('Ani__desc'),
                $disclaimer     = document.getElementById('Ani__disclaimer'),
                $culprit        = document.getElementById('Ani__culprit'),
                $bg             = document.getElementById('Ani__bg');

        const   easing          = "power2.out";

        let tl = gsap.timeline({delay: 1, paused: true});

        // tl.from($title1, {y: 20, opacity: 0, duration: .5, easing: easing})
        //     .add('images', 1.5)
        //     .to($title1, {scale: 0.5, opacity: 0, duration: 1, delay: 1, easing: 'power2.in'})
        //     .from($title2, {scale: 3, opacity: 0, duration: 0.5, easing: 'power2.in'}, '-=0.5')
        //     .from($culprit, { scale: 0.8, transformOrigin: 'bottom left', y: 20, opacity: 0, duration: 1, easing: easing}, 'images')
        //     .to($bg, {scale: 0.95, transformOrigin: 'top right', filter: 'blur(10px)', duration: 1, easing: easing}, 'images')
        //     .from($desc, {y: 20, opacity: 0, duration: 1, delay: 0.5, easing: easing})
        //     .from($disclaimer, { opacity: 0, duration: .5, easing: easing}, '-=.5')

        function inViewport(elem) {
            let elementTop = $(elem).offset().top;
            let elementBottom = elementTop + $(elem).outerHeight();
            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        }

        // Animation trigger
        $(window).on('scroll', function(){
            let inView = inViewport($WhoDrinkDrives);
            if (inView && !isPlaying) {
                tl.play();
            }
        });

        $(window).on('load', function(){
            if($('body').hasClass('easter-variant')) {
                let inView = inViewport($WhoDrinkDrives);
                if (inView && !isPlaying) {
                    tl.play();
                }
            }
        })

    }

})(jQuery);